//PUBLIC
export const INITIALISE = 'INITIALISE';
export const SET_CONTENT_DATA = 'SET_CONTENT_DATA';
export const SET_TRACKING_DATA = 'SET_TRACKING_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';
export const SET_NAVIGATION = 'SET_NAVIGATION';
export const SET_DIALOG_POPUP = 'SET_DIALOG_POPUP';
export const SET_CONTENT_TOOLTIP = 'SET_CONTENT_TOOLTIP';
export const SET_PROJECT_TITLE = 'SET_PROJECT_TITLE';
export const SET_BITE_TITLE = 'SET_BITE_TITLE';
export const SET_SCREEN_TITLE = 'SET_SCREEN_TITLE';
export const SET_MAIN_MENU_DISPLAY = 'SET_MAIN_MENU_DISPLAY';
export const STATUS_CLOSED = 'CLOSED';
export const STATUS_OPEN = 'OPEN';
export const STATUS_OPENING = 'OPENING';
export const STATUS_CLOSING = 'CLOSING';
export const SET_RESOURCES_DISPLAY = 'SET_RESOURCES_DISPLAY';
export const SET_RESOURCES_PROPS = 'SET_RESOURCES_PROPS';
export const SET_CLICK_REVEAL_DIALOG = 'SET_CLICK_REVEAL_DIALOG';
export const SET_NOTES_DISPLAY = 'SET_NOTES_DISPLAY';
export const SET_ASSET_DIALOG = 'SET_ASSET_DIALOG';
export const SET_SCREEN_DIALOG = 'SET_SCREEN_DIALOG';
export const SET_AUDIO_REF = 'SET_AUDIO_REF';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const SET_SHOW_CONTENT_OUTLINE_IN_PREVIEW = 'SET_SHOW_CONTENT_OUTLINE_IN_PREVIEW';
export const SET_INSTRUCTOR = 'SET_INSTRUCTOR';
export const SET_CURRENT_AUDIO_ID = 'SET_CURRENT_AUDIO_ID';


/** WEBPACK FOOTER **
 ** ./src/actions/actionTypes.js
 **/